import { useState, useCallback } from 'react';
/**
 * ページネーション直前に表示していた行数を取得するuse
 * TS化済: src/hooks/ui/Navigation/useLoadingPagination.ts
 * @param onPageChange
 * @param rows
 * @param unmountRef
 * @returns {*}
 */
const usePagination = (onPageChange, rows, unmountRef) => {
    const [skeletons, changeSkeletons] = useState(3);
    const wrapOnPageChange = useCallback((args) => {
        if (!unmountRef.current) {
            changeSkeletons(rows.length);
            onPageChange(args);
        }
    }, [onPageChange, rows, unmountRef]);
    return {
        onPageChange: wrapOnPageChange,
        skeletons,
    };
};
export const paginationUseCase = {
    usePagination,
};
export default paginationUseCase;
